/** Base action modal */
export const actionModalTemplateProps = {
    show: {
        type: Boolean,
        required: true,
    },
}

export const actionModalContentProps = {
    actionTitle: {
        type: String,
        required: true,
    },
    actionBody: {
        type: String,
        required: true,
    },
    cancelText: {
        type: String,
    },
}

/** Confirm Danger */
export const confirmDangerActionModalProps = {
    ...actionModalContentProps,
    confirmText: {
        type: String,
    },
}
